import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { FieldElement } from "@/react/types/Element";

// Converts a contact email field element to a FormContactEmailBlock
export const elementToBlock = (
  element: FieldElement,
  fieldIndex: number,
): BaseBlock => ({
  id: element.id.toString(),
  type: "FormContactEmailBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: element.attributes.label,
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: element.attributes.placeholder || "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: element.attributes.required,
    },
    hidden: {
      prop: "other",
      type: "boolean",
      value: element.attributes.hidden,
    },
  },
  meta: {
    elementType: "field",
    fieldType: "contact_email",
    elementId: element.id,
    elementableId: element.elementable_id,
    position: element.position,
    parentElementId: element.parent_element_id,
    fieldIndex,
    canvasNameI18n: "builder_ui.block_type.form_contact_email",
  },
});
